import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PrintIcon from '@mui/icons-material/Print';
import { Button, Typography, CircularProgress } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Print from '@mui/icons-material/Print';
import { toastr } from 'react-redux-toastr';
import { i18n } from '../../translate/i18n';
import moment from 'moment';
import confirm from '../../UI/Confirm/confirm';
import api from '../../axios/api';
import { selectUrl } from '../../axios/baseUrl';
import iconQrCode from '../../assets/qrcode.jpg';
import siteObjectToQuery from '../../utils/siteObjectToQuery';
import filterObjectToQuery from '../../utils/filterObjectToQuery';
import {
    Spinner,
} from './styles';
import { formatLanguageFromLocalStorage } from '../../utils/formatLanguageFromLocalStorage';

const localStorageLang = localStorage.getItem("i18nextLng");
const language = formatLanguageFromLocalStorage(localStorageLang);

const FileDownloadButton = ({
    type, title, documentId, disabled, filters,
}) => {
    const [loading, setLoading] = useState(false);
    const selectedServices = useSelector(state => state.services.servicesSelected);

    const fetchDownload = async ({ url, ids, requestType }) => {
        setLoading(true);
        try {
            toastr.info(i18n.t('toastrFileDownBtn.info1'), i18n.t('toastrFileDownBtn.info2'));
            const response = requestType === 'POST' ? await api.post(url, { ids }) : await api.get(url);
            if (response.status === 200) window.open(response.data.url);
        } catch (error) {
            toastr.error(i18n.t('toastrFileDownBtn.error1'), i18n.t('toastrFileDownBtn.error2'));
        }
        setLoading(false);
    };

    const fetchDownloadService = async ({ url, requestType, language }) => {
        setLoading(true);
        try {
            toastr.info(i18n.t('toastrFileDownBtn.info1'), i18n.t('toastrFileDownBtn.info2'));
            const response =  await api.get(url, {language});
            if (response.status === 200) window.open(response.data.url);
        } catch (error) {
            toastr.error(i18n.t('toastrFileDownBtn.error1'), i18n.t('toastrFileDownBtn.error2'));
        }
        setLoading(false);
    };

    const handleDownload = async (e) => {
        e.preventDefault();
        let url;
        let ids;
        let requestType = 'POST';
        switch (type) {
            case 'service': {
                url = `${selectUrl()}/reports/service/${documentId}/?language=${language}`;
                requestType = 'GET';
                await fetchDownloadService({ url, requestType, language });
                break;
            }
            case 'service-checklist': {
                url = `${selectUrl()}/reports/service_checklist/${documentId}`;
                requestType = 'GET';
                await fetchDownload({ url, requestType });
                break;
            }
            case 'zipServiceReport': {
                url = `${selectUrl()}/reports/service_report_zip/?language=${language}`;
                ids = selectedServices;
                await fetchDownload({ url, ids, requestType });
                break;
            }
            case 'calendar': {
                let queryParams = `?after=${moment(filters.date).utcOffset('-0300').startOf('month')}&before=${moment(filters.date).utcOffset('-0300').endOf('month')}`;
                queryParams += `&${filters.selectedSites && filters.selectedSites.length > 0 ? `sites=${siteObjectToQuery(filters.selectedSites)}` : ''}`;
                queryParams += `${filters.filteredUsers && filters.filteredUsers.length > 0 ? `&users=${filterObjectToQuery(filters.filteredUsers)}` : ''}`;
                queryParams += `${filters.filteredUsersMaintenances && filters.filteredUsersMaintenances.length > 0 ? `&usersMaintenances=${filterObjectToQuery(filters.filteredUsersMaintenances)}` : ''}`;
                queryParams += `${filters.filteredEquipmentModels && filters.filteredEquipmentModels.length > 0 ? `&equipment_models=${filterObjectToQuery(filters.filteredEquipmentModels)}` : ''}`;
                queryParams += `${filters.filteredEquipmentGroups && filters.filteredEquipmentGroups.length > 0 ? `&equipment_groups=${filterObjectToQuery(filters.filteredEquipmentGroups)}` : ''}`;
                queryParams += `${filters.filteredServiceTypes && filters.filteredServiceTypes.length > 0 ? '&serviceType=' + filterObjectToQuery(filters.filteredServiceTypes) : ''}`;
                queryParams += `${filters.filteredFrequencies && filters.filteredFrequencies.length > 0 ? '&frequencies=' + filterObjectToQuery(filters.filteredFrequencies) : ''}`
                queryParams += `${filters.filteredPlaces && filters.filteredPlaces.length > 0 ? `&places=${filterObjectToQuery(filters.filteredPlaces)}` : ''}`;
                queryParams += `${filters.filteredModules && filters.filteredModules.length > 0 ? `&modules=${filters.filteredModules.join(',')}` : ''}`;
                queryParams += `${filters.filteredAreas && filters.filteredAreas.length > 0 ? `&areas=${filterObjectToQuery(filters.filteredAreas)}` : ''}`;
                queryParams += `${filters.filteredCompanies && filters.filteredCompanies.length > 0 ? `&companies=${filterObjectToQuery(filters.filteredCompanies)}` : ''}`;
                queryParams += `${filters.filteredStatus && filters.filteredStatus.length > 0 ? `&status=${filterObjectToQuery(filters.filteredStatus)}` : ''}`;
                queryParams += `${filters.filteredStatusMaintenances && filters.filteredStatusMaintenances.length > 0 ? `&statusMaintenances=${filterObjectToQuery(filters.filteredStatusMaintenances)}` : ''}`;


                url = `${selectUrl()}/calendars/equipment_report${queryParams}`;
                requestType = 'GET';
                await fetchDownload({ url, requestType, requestType });
                break;
            }
            case 'qrcode': {
                ids = documentId.map(el => (el._id));
                url = `${selectUrl()}/equipments/printqrcodes`;
                await fetchDownload({ url, ids, requestType });
                break;
            }
            case 'small_qrcode': {
                ids = [documentId];
                url = `${selectUrl()}/equipments/printqrcodes`;
                await fetchDownload({ url, ids, requestType });
                break;
            }
            case 'place_list_button': {
                if (!loading) {
                    setLoading(true);
                    const response = await api.get(`${selectUrl()}/places/${documentId._id}/checkprintqrcode`);
                    if (response.status === 200) {
                        const { equipments, leafs } = response.data;
                        if (equipments > 0) {
                            confirm(i18n.t('place_list_button.confirm') + equipments+ i18n.t('place_list_button.confirm1') ,
                                {
                                    title: i18n.t('place_list_button.title'),
                                    titleColor: 'green',
                                    disableBackdrop: true,
                                }).then(
                                    () => { },
                                    async () => {
                                        toastr.info(i18n.t('toastrFileDownBtn.info1'), i18n.t('toastrFileDownBtn.info2'));
                                        const responseQrCodes = await api.get(`${selectUrl()}/places/${documentId._id}/printqrcode`);
                                        if (responseQrCodes.status === 200) {
                                            window.open(responseQrCodes.data.url);
                                        }
                                    },
                                );
                        } else {
                            confirm(i18n.t('place_list_button.else'),
                                {
                                    title: i18n.t('place_list_button.title'),
                                    titleColor: 'red',
                                    disableBackdrop: true,
                                }).then(() => { },
                                    async () => { });
                        }
                    }
                    setLoading(false);
                }
                break;
            }
            default: {
                break;
            }
        }
    };

    return <>
        {type === 'service' && (
            <div style={styles.serviceContainer}>
                <Button
                    variant='outlined'
                    aria-label="add"
                    onClick={handleDownload}
                    disabled={disabled || loading}
                    style={{ display: 'flex' }}
                    startIcon={loading ? <CircularProgress size={16} style={{ color: 'green' }} /> : <Print style={styles.icon} />}
                >
                    {title}
                </Button>
            </div>
        )}
        {type === 'service-checklist' && (
            <div style={styles.serviceContainer}>
                <Button
                    variant='outlined'
                    aria-label="add"
                    onClick={handleDownload}
                    disabled={disabled || loading}
                    style={{ display: 'flex' }}
                    startIcon={loading ? <CircularProgress size={16} style={{ color: 'green' }} /> : <Print style={styles.icon} />}
                >
                    CHECKLIST (PDF)
                </Button>
            </div>
        )}
        {type === 'zipServiceReport'
            && (
            <Button
              variant='outlined'
              aria-label="add"
              onClick={handleDownload}
              disabled={disabled || loading}
              startIcon={loading ? <CircularProgress size={14} style={{ color: 'green' }} /> : <Print style={styles.icon} />}
            >
              {i18n.t('buttonFileDownBtn.text')}
            </Button>
            )
        }
        {type === 'calendar'
            && (
                <Button
                    variant="outlined"
                    onClick={handleDownload}
                    disabled={disabled || loading}
                    style={{ width: 'fit-content'}}
                    title={title}
                >
                    {!loading && <PrintIcon style={{ ...styles.pdfIcon, marginRight: 5 }} />}
                    {!loading && <Typography style={{ fontSize: 14 }}>{title}</Typography>}
                    {loading && <Spinner><div className="loader" /></Spinner>}
                </Button>
            )
        }
        {type === 'qrcode'
            && (
                <Button
                    variant="outlined"
                    color="secondary"
                    onClick={handleDownload}
                    disabled={disabled || loading}
                    style={styles.downloadButton}
                    title={title}
                >
                    {!loading && <img src={iconQrCode} style={{ ...styles.iconQrCode, marginRight: 10 }} alt="QRCODE" />}
                    {!loading && <Typography style={{ fontSize: 14 }}>{i18n.t('place_list_button.title')}</Typography>}
                    {loading && <Spinner><div className="loader" /></Spinner>}
                </Button>
            )
        }
        {type === 'small_qrcode'
            && (
                <IconButton
                    onClick={handleDownload}
                    disabled={disabled || loading}
                    title={i18n.t('iconButtonFileDownBtn.title')}
                    style={styles.downloadButton2}
                    size="large">
                    {!loading && <img src={iconQrCode} style={styles.iconQrCode} alt="QRCODE" />}
                    {loading && <Spinner><div className="loader" /></Spinner>}
                </IconButton>
            )
        }
        {type === 'place_list_button'
            && (
                <>
                    {!loading && <img onClick={handleDownload} src={iconQrCode} alt="QRCODE" style={styles.downloadButton3} />}
                    {loading && <Spinner margin="5px" style={styles.downloadButton3}><div className="loader" /></Spinner>}
                </>
            )
        }
    </>;
};

const styles = {
    pdfIcon: {
        height: 26,
        width: 26,
        color: '#707070',
    },
    downloadButton: {
        minWidth: 200,
        maxHeight: 36,
    },
    downloadButton2: {
        maxHeight: 40,
        maxWidth: 40,
        marginLeft: 10,
    },
    downloadButton3: {
        maxHeight: 25,
        maxWidth: 25,
        marginLeft: 8,
        marginRight: 8,
        marginTop: 0,
        cursor: 'pointer',
    },
    iconQrCode: {
        width: '1.5rem',
    },
		serviceContainer: {
			display: 'flex',
			alignItems: 'center',
			margin: '0 1rem'
		}
};

export default FileDownloadButton;
